export const InfoBarIcon = () => {
  return (
    <div>
      <svg
        width="32"
        height="32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="info-bar-icon"
      >
        <path
          d="M19.4 15H17v-2.4a7 7 0 01-.8-2 9 9 0 105.2 5.2 7 7 0 01-2-.8zM16 8.4a7 7 0 117.6 7.6A11 11 0 1116 8.4zM10 19a1 1 0 110-2 1 1 0 010 2zm-.7 3.7a1 1 0 011.4-1.4 2.1 2.1 0 00.5.3c.5.3 1 .4 1.8.4.6 0 1.4-.3 2.2-.8a8.4 8.4 0 001-.9 1 1 0 011.5 1.4l-1.4 1.1A6 6 0 0113 24c-1 0-2-.2-2.7-.6a4 4 0 01-1-.7zM16 18a1 1 0 110-2 1 1 0 010 2zm7-9v3.5a.5.5 0 00.5.5h1a.5.5 0 000-1H24V8.5a.5.5 0 00-.5-.5h-1a.5.5 0 000 1h.5zm0-2a1 1 0 100-2 1 1 0 000 2z"
          fill="#3643BA"
        />
      </svg>
    </div>
  );
};
